import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Link } from "react-router-dom"
import NotificationsBlock from './Notifications_block'
import { useDispatch, useSelector } from 'react-redux'
import { getnotifcationsAction } from '../../redux/actions/notificationsActions'
import NotificationsAlerts from './NotificationAlert'
import { socket } from "../../utils/socket.js"
import notificationSound from "../images/audio.mp3";
import dayjs from 'dayjs'

const Notifications = () => {

    const dispatch = useDispatch()
    const { unread_count, notifications, count, urgent_count } = useSelector(state => state.notifications)
    const { message } = useSelector(state => state.marknotifications)

    const [type, setType] = useState("")
    const [notify_type, setNotify_type] = useState("")

    const wrapperRef = useRef(null)
    const audioRef = useRef(null);

    const [showNotifications, setShowNotifications] = useState(false)
    const [notificationData, setNotificationData] = useState([])

    const todayNotifications = [];
    const yesterdayNotifications = [];
    const earlierNotifications = [];

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setShowNotifications(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside)

        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }

    }, [])

    useEffect(() => {
        audioRef.current = new Audio(notificationSound);
    }, [])

    useEffect(() => {

        const query = {}
        if (type) query.type = type
        if (notify_type) query.notify_type = notify_type

        dispatch(getnotifcationsAction(query))

    }, [dispatch, type, notify_type])

    useEffect(() => {

        if (message) {
            const query = {}
            if (type) query.type = type
            if (notify_type) query.notify_type = notify_type

            dispatch(getnotifcationsAction(query))
            dispatch({ type: "MARK_NOTIFICATIONS_RESET" })
        }

    }, [dispatch, message, type, notify_type])

    useEffect(() => {

        const handleNotification = (data) => {

            setNotificationData(prev => [...prev, data])

            // 🔊 sound
            if (audioRef.current) {
                audioRef.current.currentTime = 0
                audioRef.current.play().catch(err => {
                    console.log("Audio play blocked:", err)
                })
            }

            const query = {}
            if (type) query.type = type
            if (notify_type) query.notify_type = notify_type

            dispatch(getnotifcationsAction(query))
        }

        socket.on("new_notification", handleNotification)

        return () => {
            socket.off("new_notification", handleNotification)
        }

    }, [dispatch, type, notify_type])

    // ✅ FIXED DAY LOGIC (NO PLUGINS)
    notifications?.forEach((n) => {

        const date = dayjs(n.created_at)
        const now = dayjs()

        if (date.isSame(now, 'day')) {
            todayNotifications.push(n)
        }
        else if (date.isSame(now.subtract(1, 'day'), 'day')) {
            yesterdayNotifications.push(n)
        }
        else {
            earlierNotifications.push(n)
        }
    })

    return (
        <Fragment>
            <div className="relative">
                <button className="relative flex items-center justify-center w-10 h-10 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                    onClick={() => setShowNotifications(prev => !prev)}
                >
                    <i className="fa-regular fa-bell text-xl text-[#5a6a85] dark:text-slate-300"></i>

                    <span className="flex-center absolute top-1 right-1
                       w-4 h-4 rounded-full bg-red-500
                      text-[10px] text-white shadow-sm">

                        {unread_count || 0}

                    </span>
                </button>

                {/* Dropdown */}
                <div className={`fixed top-0 right-0 w-[85vw] sm:w-[400px] bg-white dark:bg-slate-950 shadow-2xl z-[10000000]
                    transition-transform duration-500 ease-out h-screen flex flex-col
                    ${showNotifications ? "translate-x-0" : "translate-x-full invisible"}`}
                    ref={wrapperRef}
                >
                    {/* HEADER */}
                    <div className="px-6 py-5 flex justify-between items-center border-b border-gray-100 dark:border-slate-800">
                        <div className="flex gap-3 items-center">
                            <div className="w-10 h-10 bg-indigo-50 dark:bg-indigo-500/15 rounded-xl flex-center text-indigo-600 dark:text-indigo-300 text-xl">
                                <i className="fa-regular fa-bell"></i>
                            </div>
                            <div>
                                <h3 className='font-bold text-lg text-zinc-800 dark:text-slate-100 font-jakarta'>Notifications</h3>
                                <p className='text-xs text-zinc-500 dark:text-slate-400'>{unread_count || 0} unread messages</p>
                            </div>
                        </div>

                        <button
                            className='w-8 h-8 flex-center rounded-full bg-zinc-100 dark:bg-slate-800 text-zinc-500 dark:text-slate-300 hover:bg-zinc-200 dark:hover:bg-slate-700 hover:text-zinc-800 dark:hover:text-white transition-colors'
                            onClick={() => setShowNotifications(false)}
                        >
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                    </div>

                    {/* FILTERS */}
                    <div className="grid grid-cols-3 gap-2 p-4 bg-zinc-50/50 dark:bg-slate-900/70 border-b border-gray-100 dark:border-slate-800">

                        <button className={`flex justify-between items-center rounded-xl p-2.5 transition-all
                            ${type === "" && notify_type === "" ? "bg-indigo-600 text-white shadow-md shadow-indigo-200 dark:shadow-none" : "bg-white dark:bg-slate-900 text-zinc-600 dark:text-slate-300 border border-zinc-200 dark:border-slate-700 hover:border-zinc-300 dark:hover:border-slate-600"}`}
                            onClick={() => {
                                setType("")
                                setNotify_type("")
                            }}
                        >
                            <span className="font-medium text-sm">All</span>
                            <span className={`inline-block min-w-[24px] h-6 text-center leading-6 rounded-lg text-xs font-bold
                                ${type === "" && notify_type === "" ? "bg-white/20 text-white" : "bg-zinc-100 dark:bg-slate-800 text-zinc-600 dark:text-slate-300"}`}>
                                {count || 0}
                            </span>
                        </button>

                        <button className={`flex justify-between items-center rounded-xl p-2.5 transition-all
                            ${type === "" && notify_type === "unread" ? "bg-indigo-600 text-white shadow-md shadow-indigo-200 dark:shadow-none" : "bg-white dark:bg-slate-900 text-zinc-600 dark:text-slate-300 border border-zinc-200 dark:border-slate-700 hover:border-zinc-300 dark:hover:border-slate-600"}`}
                            onClick={() => {
                                setType("")
                                setNotify_type("unread")
                            }}
                        >
                            <span className="font-medium text-sm">Unread</span>
                            <span className={`inline-block min-w-[24px] h-6 text-center leading-6 rounded-lg text-xs font-bold
                                ${type === "" && notify_type === "unread" ? "bg-white/20 text-white" : "bg-zinc-100 dark:bg-slate-800 text-zinc-600 dark:text-slate-300"}`}>
                                {Number(unread_count) > 99 ? "99+" : unread_count || 0}
                            </span>
                        </button>

                        <button className={`flex justify-between items-center rounded-xl p-2.5 transition-all
                            ${type === "WARNING" && notify_type === "" ? "bg-red-600 text-white shadow-md shadow-red-200 dark:shadow-none" : "bg-white dark:bg-slate-900 text-zinc-600 dark:text-slate-300 border border-zinc-200 dark:border-slate-700 hover:border-zinc-300 dark:hover:border-slate-600"}`}
                            onClick={() => {
                                setType("WARNING")
                                setNotify_type("")
                            }}
                        >
                            <span className="font-medium text-sm">Urgent</span>
                            <span className={`inline-block min-w-[24px] h-6 text-center leading-6 rounded-lg text-xs font-bold
                                ${type === "WARNING" && notify_type === "" ? "bg-white/20 text-white" : "bg-zinc-100 dark:bg-slate-800 text-zinc-600 dark:text-slate-300"}`}>
                                {Number(urgent_count) > 99 ? "99+" : urgent_count || 0}
                            </span>
                        </button>

                    </div>

                    {/* LIST */}
                    <div className="flex-1 overflow-y-auto premium-scrollbar p-4 bg-zinc-50/50 dark:bg-slate-950">

                        {notifications?.length === 0 && (
                            <div className="text-sm font-medium text-zinc-400 flex-center h-32 flex-col gap-2">
                                <i className="fa-regular fa-folder-open text-3xl"></i>
                                No notifications to show
                            </div>
                        )}

                        {todayNotifications.length > 0 && (
                            <div className="mb-6">
                                <h4 className="text-xs font-bold text-zinc-400 uppercase tracking-wider mb-3">Today</h4>
                                <div className="space-y-3">
                                    {todayNotifications.map((n, i) => (
                                        <NotificationsBlock key={i} notification={n} setShowNotifications={setShowNotifications} />
                                    ))}
                                </div>
                            </div>
                        )}

                        {yesterdayNotifications.length > 0 && (
                            <div className="mb-6">
                                <h4 className="text-xs font-bold text-zinc-400 uppercase tracking-wider mb-3 mt-4">Yesterday</h4>
                                <div className="space-y-3">
                                    {yesterdayNotifications.map((n, i) => (
                                        <NotificationsBlock key={i} notification={n} setShowNotifications={setShowNotifications} />
                                    ))}
                                </div>
                            </div>
                        )}

                        {earlierNotifications.length > 0 && (
                            <div>
                                <h4 className="text-xs font-bold text-zinc-400 uppercase tracking-wider mb-3 mt-4">Earlier</h4>
                                <div className="space-y-3">
                                    {earlierNotifications.map((n, i) => (
                                        <NotificationsBlock key={i} notification={n} setShowNotifications={setShowNotifications} />
                                    ))}
                                </div>
                            </div>
                        )}

                    </div>

                    {/* FOOTER */}
                    <div className="p-4 border-t border-gray-100 dark:border-slate-800 bg-white dark:bg-slate-950">
                        <Link to={'/notifications'}
                            className='w-full flex justify-center items-center gap-2 bg-gradient-to-r from-indigo-600 to-indigo-700 text-white font-semibold py-3 px-6 rounded-xl hover:shadow-lg hover:shadow-indigo-100 transition-all active:scale-[0.98]'
                            onClick={() => setShowNotifications(false)}
                        >
                            Read All Notifications
                            <i className="fa-solid fa-arrow-right-long"></i>
                        </Link>
                    </div>
                </div>
            </div>

            {notificationData?.map((n, index) => (
                <NotificationsAlerts
                    key={n.notification_id || index}
                    notificationData={n}
                    removeNotification={() => {
                        setNotificationData(prev =>
                            prev.filter(item => item !== n)
                        )
                    }}
                />
            ))}

        </Fragment>
    )
}

export default Notifications
